import { MessageCircleQuestion } from "lucide-react";

import { getFollowUpQuestionByReminder } from "@/apis";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import useGlobalStore from "@/stores/useGlobalStore";
import { useNavigate, useParams } from "react-router-dom";
import useChatStore from "@/stores/useChatStore";
import { ReactComponent as AISuggestIcon } from "@/assets/ai-suggest.svg";

function FollowUpQuestion({ className, isPopupContent }) {
  const business = useGlobalStore((state) => state.business);
  const { reminderId } = useParams();
  const [questions, setQuestions] = useState([]);
  const setQuestion = useChatStore((store) => store.setQuestion);
  const handleAskQuestionStream = useChatStore((store) => store.handleAskQuestionStream);
  const handleResetChatStore = useChatStore((store) => store.handleResetChatStore);
  const navigate = useNavigate();

  const onQuestionClick = (question) => {
    handleResetChatStore();
    setQuestion(question);
    handleAskQuestionStream(reminderId, true); // Use streaming instead of regular API
    setQuestion("");
    navigate("/"); // Navigate to chat page
  };

  const fetchQuestions = async () => {
    const folloupResp = await getFollowUpQuestionByReminder({ business, reminderId, isFollowUp: true });
    setQuestions(folloupResp || []);
  };

  useEffect(() => {
    fetchQuestions();
  }, []);

  if (!questions?.length) return null;

  return (
    <div className={cn("mb-8 mt-5", className)}>
      <div className="mt-4 mb-3 flex align-center items-center">
        <MessageCircleQuestion size={18} color="#218BEC" />
        <span className={cn("text-xs ml-1 text-blue-500 font-medium", isPopupContent ? "text-sm" : "text-md")}>Câu hỏi đề xuất:</span>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {questions.map((question, idx) => (
          <Button
            key={question}
            variant="outline"
            className={cn(
              "h-auto py-2 px-3 ml-1 justify-start text-left flex items-center gap-2",
              "rounded-xl border border-blue-200 bg-gradient-to-br from-blue-100/60 to-white shadow-sm",
              "text-sm font-medium text-slate-800",
              // Ensure hover becomes pure white (override gradient)
              "hover:from-white hover:to-white hover:bg-white focus-visible:ring-2 focus-visible:ring-blue-300",
              "animate-bound-in-up"
            )}
            style={{ animationDelay: `${idx * 360}ms` }}
            onClick={() => onQuestionClick(question)}
          >
            <AISuggestIcon width={16} height={16} />
            {question}
          </Button>
        ))}
      </div>
    </div>
  );
}

export default FollowUpQuestion;
